import { useEffect, useRef, useState } from "react";
import { player, BOUNDS, approachPoint } from "@/components/clinic/playerStore";

const SIZE = 150;
const sx = (x) => ((x - BOUNDS.minX) / (BOUNDS.maxX - BOUNDS.minX)) * (SIZE - 16) + 8;
const sz = (z) => ((z - BOUNDS.minZ) / (BOUNDS.maxZ - BOUNDS.minZ)) * (SIZE - 16) + 8;

export function Minimap({ departments, onPick, targetSlug }) {
  const [, tick] = useState(0);
  const ref = useRef();
  useEffect(() => {
    const t = setInterval(() => tick((v) => v + 1), 120);
    return () => clearInterval(t);
  }, []);
  const deg = (-player.yaw * 180) / Math.PI;
  return (
    <div data-testid="minimap" className="glass-dark rounded-2xl p-2 text-white" ref={ref}>
      <div className="mb-1 flex items-center justify-between px-1 text-[10px] font-semibold uppercase tracking-widest text-cyan-200">
        <span>Mappa</span>
        <span className="font-mono">{player.x.toFixed(0)},{player.z.toFixed(0)}</span>
      </div>
      <svg width={SIZE} height={SIZE} className="rounded-xl bg-sky-950/60">
        <rect x={4} y={4} width={SIZE - 8} height={SIZE - 8} rx={8} fill="none" stroke="#86DDB0" strokeOpacity={0.35} />
        <circle cx={sx(0)} cy={sz(-2.6)} r={10} fill="#4FBF87" fillOpacity={0.25} stroke="#9BE3BC" strokeOpacity={0.5} />
        {departments.map((d) => {
          const a = approachPoint(d);
          return (
            <g key={d.id} onClick={() => onPick(d)} className="cursor-pointer" data-testid={`minimap-pin-${d.slug}`}>
              <circle cx={sx(a.x)} cy={sz(a.z)} r={targetSlug === d.slug ? 7 : 5} fill={targetSlug === d.slug ? "#7EE0A8" : "#7ED3A4"} />
              <title>{d.title}</title>
            </g>
          );
        })}
        <g transform={`translate(${sx(player.x)} ${sz(player.z)}) rotate(${deg})`}>
          <path d="M0,-8 L5,5 L0,2 L-5,5 Z" fill="#ffffff" />
        </g>
      </svg>
    </div>
  );
}
